import CryptoJS from "crypto-js";

export const decryptAES256 = (encryptedBase64, secretKey = "karthik") => {
  // 🚨 Guard clauses
  if (!encryptedBase64) {
    throw new Error("decryptAES256: No data provided");
  }

  if (typeof encryptedBase64 !== "string") {
    throw new Error(
      `decryptAES256: Expected base64 string, got ${typeof encryptedBase64}`
    );
  }

  let rawData;
  try {
    rawData = CryptoJS.enc.Base64.parse(encryptedBase64);
  } catch (e) {
    throw new Error("decryptAES256: Invalid Base64 data");
  }

  // Extract IV (first 16 bytes)
  const iv = CryptoJS.lib.WordArray.create(
    rawData.words.slice(0, 4),
    16
  );

  // Extract ciphertext
  const ciphertext = CryptoJS.lib.WordArray.create(
    rawData.words.slice(4),
    rawData.sigBytes - 16
  );

  // SHA-256 key
  const key = CryptoJS.SHA256(secretKey);

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext },
    key,
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  const result = decrypted.toString(CryptoJS.enc.Utf8);

  if (!result) {
    throw new Error("decryptAES256: Decryption failed (empty result)");
  }

  return result;
};
